import { hasVersions } from '@agavi/blocks';

/**
 * Does this task draw anything, so that Reroll has something to do?
 *
 * Extracted from the Preview bottom bar's inline gate, which asked only whether the task had
 * named VARIABLES. That was the whole of a task's randomness when it was written and is not any
 * more: a task whose scenarios come from a display block's bank has no named variables at all,
 * so the one control that could show a second scenario was never rendered — making the feature
 * untestable from the surface it exists for.
 *
 * A function rather than a boolean in the JSX because the question has now been wrong once and
 * will grow a third source eventually. One place to add it, and one place to test it.
 */
export function taskHasDraw(
  variables: { name?: string }[] | undefined,
  blocks: { data?: unknown }[] | undefined,
): boolean {
  // A variable with no name is a half-authored row, not something to draw.
  if ((variables ?? []).some(v => v.name)) return true;
  // A bank of one is not a bank — `hasVersions` is what draws that line, and `rollVersions`
  // agrees, so a one-variant block really would make Reroll do nothing.
  return (blocks ?? []).some(b => hasVersions((b.data ?? {}) as { versions?: unknown[] }));
}
